import * as React from 'react';

import { Root } from './styled';

const HelpCenterNoPortal: React.StatelessComponent = () => {
    return <Root id="no-portal-content"></Root>;
};

export default HelpCenterNoPortal;
